<template>
  <div class="transaction_detail_box">
    <Tabbar :title="$t('transactionDetail.title')" :back="onBack" />
    <div class="transaction_detail">
      <!-- 金额 -->
      <div class="transaction_amount">
        <div class="dollar_icon">
          {{ transOut.indexOf(transDetail.type) > -1 ? '-$' : '$' }}
        </div>
        <div>{{ transDetail.amount }}</div>
      </div>
      <!-- 状态 -->
      <div class="transaction_status">
        <div v-if="getOrderStatus() === 'PENDING'" class="pending">
          {{ $t('transactionDetail.pending') }}
          <div v-if="transDetail.withdrawType === 3">
            {{ $t('transactionDetail.bankPendingText') }}
          </div>
          <div v-else-if="transDetail.withdrawType > 3">
            {{ $t('transactionDetail.pendingText', [withdrawTypes[transDetail.withdrawType]]) }}
          </div>
        </div>
        <div v-if="getOrderStatus() === 'COMPLETED'">
          {{ $t('transactionDetail.completed') }}
        </div>
        <div v-if="getOrderStatus() === 'SUCCESS'">
          {{ $t('transactionDetail.success') }}
        </div>
        <div v-if="getOrderStatus() === 'INIT_START'">INIT_START</div>
        <div v-if="getOrderStatus() === 'FAILED'" class="error">
          {{ $t('transactionDetail.failed') }}
        </div>
        <div v-if="getOrderStatus() === 'CANCELLED'">
          {{ $t('transactionDetail.cancelled') }}
        </div>
        <div v-if="getOrderStatus() === 'ON_HOLD'" class="error">
          {{ $t('transactionDetail.onHold') }}
        </div>
      </div>
      <!-- 失败原因 -->
      <div v-if="getOrderStatus() === 'FAILED'" class="fail_reason">
        {{ getFailedReason() }}
      </div>
      <!-- 描述 -->
      <div v-if="transDetail.description" class="transaction_description">
        {{ transDetail.description }}
      </div>
      <!-- 创建日期 -->
      <div class="trans_item" :style="{ marginTop: '0.22rem' }">
        <div class="trans_item_name">{{ $t('transactionDetail.creationDate') }}</div>
        <div class="trans_item_result">{{ transDetail.createTime }} (GMT +0)</div>
      </div>
      <!-- 状态最后变更日期 -->
      <div class="trans_item">
        <div class="trans_item_name">{{ $t('transactionDetail.lastStatusDate') }}</div>
        <div class="trans_item_result">{{ getUpdateTime() }}</div>
      </div>
      <!-- 请求金额 -->
      <div v-if="transDetail.type === 9" class="trans_item">
        <div class="trans_item_name">{{ $t('transactionDetail.requestedAmount') }}</div>
        <div class="trans_item_result">
          {{ format('USD', transDetail.amount) }}
        </div>
      </div>
      <!-- 应付金额 -->
      <div class="trans_item">
        <div class="trans_item_name">
          {{
            transDetail.type === 0
              ? $t('transactionDetail.receiveAmount')
              : transDetail.type === 1
                ? $t('transactionDetail.transferAmount')
                : $t('transactionDetail.amountToPay')
          }}
        </div>
        <div v-if="transDetail.type === 9" class="trans_item_result">
          {{ format(transDetail.extParams.currency, transDetail.extParams.amount) }}
        </div>
        <div v-else class="trans_item_result">
          {{ format('USD', transDetail.amount) }}
        </div>
      </div>
      <!-- 交易费用 -->
      <div v-if="transDetail.type !== 0" class="trans_item">
        <div class="trans_item_name">
          {{ transDetail.type === 1 ? $t('transactionDetail.transferFee') : $t('transactionDetail.processingFee') }}
        </div>
        <div class="trans_item_result">
          {{ format('USD', transDetail.fee) }}
        </div>
      </div>
    </div>
    <div v-if="transDetail.type === 9" class="transaction_detail">
      <!-- 国家 -->
      <div class="trans_item" :style="{ marginTop: '0' }">
        <div class="trans_item_name">{{ $t('transactionDetail.country') }}</div>
        <div class="trans_item_result">
          {{ getCountryName(transDetail.extParams.countryNo) }}
        </div>
      </div>
      <!-- 用户名 -->
      <div class="trans_item">
        <div class="trans_item_name">{{ $t('transactionDetail.name') }}</div>
        <div class="trans_item_result">{{ getName() }}</div>
      </div>
      <!-- 提现方式 -->
      <div class="trans_item">
        <div class="trans_item_name">{{ $t('transactionDetail.method') }}</div>
        <div class="trans_item_result">
          {{ withdrawTypes[transDetail.withdrawType] }}
        </div>
      </div>
      <!-- 账户 -->
      <div class="trans_item">
        <div class="trans_item_name">{{ $t('account.account') }}</div>
        <div class="trans_item_result">{{ getBankAccount() }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import moment from 'moment'

const payermaxStatus = {
  '-2': 'PENDING',
  '-1': 'PENDING',
  3: 'PENDING',
  1: 'COMPLETED',
  2: 'FAILED',
  4: 'CANCELLED'
}
const epayStatus = {
  '-10': 'CANCELLED',
  '-1': 'PENDING',
  0: 'PENDING',
  9: 'PENDING',
  6: 'FAILED',
  7: 'COMPLETED'
}
const orderStatusEnum = {
  '00': {
    0: 'PENDING',
    1: 'COMPLETED',
    2: 'FAILED'
  },
  31: {
    '-2': 'PENDING',
    '-1': 'PENDING',
    0: 'PENDING',
    4: 'PENDING',
    1: 'COMPLETED',
    2: 'CANCELLED',
    3: 'FAILED',
    5: 'ON_HOLD'
  }, // dlocal
  32: payermaxStatus,
  33: epayStatus,
  34: {
    '-2': 'PENDING',
    '-1': 'PENDING',
    0: 'PENDING',
    1: 'PENDING',
    2: 'FAILED',
    3: 'COMPLETED'
  }, // ott
  4: payermaxStatus,
  5: payermaxStatus,
  6: payermaxStatus,
  7: payermaxStatus,
  8: payermaxStatus,
  9: payermaxStatus,
  10: {}, // paypal
  11: epayStatus,
  14: {
    2: 'PENDING',
    4: 'COMPLETED',
    5: 'FAILED'
  },
  15: {
    '-1': 'INIT_START',
    1: 'PENDING',
    2: 'FAILED',
    3: 'SUCCESS'
  },
  16: {
    0: 'PENDING',
    1: 'PENDING',
    2: 'COMPLETED',
    3: 'FAILED',
    4: 'FAILED'
  },
  17: {
    0: 'PENDING',
    11: 'PROCESSING',
    14: 'COMPLETED',
    15: 'CLOSE'
  },
  35: {
    '-2': 'PENDING',
    '-1': 'PENDING',
    0: 'PENDING',
    1: 'COMPLETED',
    2: 'FAILED'
  },
  38: {
    '-1': 'PENDING',
    3: 'PENDING',
    1: 'COMPLETED',
    2: 'FAILED',
    5: 'PENDING'
  },
  316: {
    '-2': 'PENDING',
    '-1': 'PENDING',
    0: 'PENDING',
    1: 'COMPLETED',
    2: 'FAILED',
    3: 'FAILED',
    4: 'FAILED'
  }
}

export default {
  name: 'TransactionDetail',
  components: {
    Tabbar
  },
  data() {
    return {
      loading: true,
      transOut: [1, 9, 14, 4],
      transDetail: {
        extParams: {}
      },
      withdrawTypes: [
        undefined,
        undefined,
        undefined,
        'Bank Card',
        'GCash',
        'PayMaya',
        'Coins.ph',
        'GoPay',
        'OVO',
        'DANA',
        'PayPal',
        'Epay',
        undefined,
        undefined,
        'USDT'
      ]
    }
  },
  created() {
    this.getTransDetail()
  },
  methods: {
    getOrderStatus() {
      const withdrawType = this.transDetail.extParams['withdrawType'] || ''
      const bankType = this.transDetail.extParams['bankType'] || ''
      const statusEnum = orderStatusEnum[withdrawType + '' + bankType || '00']
      // 特殊处理withdrawType + "" + bankType为38时三方返回了字符串,需要对应数字
      if (
        withdrawType + '' + bankType === '38' &&
        this.transDetail.extParams['cashOutStatus'] &&
        typeof this.transDetail.extParams['cashOutStatus'] === 'string'
      ) {
        const valueStatusMap = {
          Initiated: 3,
          Processing: 3,
          Rejected: 2,
          Failed: 2,
          Success: 1
        }
        this.transDetail.extParams['cashOutStatus'] = valueStatusMap[this.transDetail.extParams['cashOutStatus']]
      }
      if (statusEnum) {
        const status =
          statusEnum[
            this.transDetail.extParams['status'] ||
              this.transDetail.extParams['cashOutStatus'] ||
              this.transDetail.status
          ]
        switch (status) {
          case 'PENDING':
            return 'PENDING'
          case 'COMPLETED':
            return 'COMPLETED'
          case 'FAILED':
            return 'FAILED'
          case 'CANCELLED':
            return 'CANCELLED'
          case 'ON_HOLD':
            return 'ON_HOLD'
          case 'INIT_START':
            return 'INIT_START'
          case 'SUCCESS':
            return 'SUCCESS'
          default:
            return status
        }
      }
      return this.transDetail.status
    },
    getBankAccount() {
      const account =
        this.transDetail.extParams['account'] ||
        this.transDetail.extParams['bankAccountNo'] ||
        this.transDetail.extParams['bankAccount']
      return this.formatAccount(account)
    },
    getName() {
      let name = this.transDetail.extParams['name']
      if (!name) {
        const firstName = this.transDetail.extParams['firstName'] || this.transDetail.extParams['beneficiaryName']
        const lastName = this.transDetail.extParams['lastName'] || this.transDetail.extParams['beneficiaryLastname']
        if (firstName) {
          return firstName + ' ' + (lastName || '')
        } else {
          return lastName || ''
        }
      }
      return name
    },
    getFailedReason() {
      let statusReason = this.transDetail.extParams['statusReason'] || this.transDetail.extParams['description'] || ''
      return statusReason
    },
    getUpdateTime() {
      if (this.transDetail['updateTime']) {
        const updateTime1 = moment(this.transDetail['updateTime'])
        let updateTime2
        if (this.transDetail.extParams['updateTime']) {
          updateTime2 = moment(this.transDetail.extParams['updateTime'])
        } else {
          updateTime2 = updateTime1
        }
        if (updateTime1.isAfter(updateTime2)) {
          return updateTime1.format('YYYY-MM-DD HH:mm:ss') + ' (GMT +0)'
        } else {
          return updateTime2.format('YYYY-MM-DD HH:mm:ss') + ' (GMT +0)'
        }
      } else {
        return '(GMT +0)'
      }
    },
    onBack() {
      this.$router.back()
    },
    format(currency, value) {
      if (value !== undefined) {
        return new Intl.NumberFormat('en', {
          style: 'currency',
          currency: currency || 'USD',
          currencyDisplay: 'symbol'
        }).format(value)
      } else {
        return '$-.--'
      }
    },
    formatAccount(account) {
      if (account) {
        const len = account.length
        if (len > 8) {
          return account.substr(0, 4) + '****' + account.substr(len - 4, len)
        } else if (len > 4) {
          return account.substr(0, 2) + '***' + account.substr(len - 2, len)
        }

        return account
      }

      return account
    },
    getCountryName(countryNo) {
      const country = this.$store.state.countries.find((each) => each.countryNo === countryNo)
      if (country) return country.countryEnName
      else return '-'
    },
    getTransDetail() {
      if (this.$route.query.hasOwnProperty('activityNo')) {
        const activityNo = this.$route.query.activityNo
        this.$http
          .get(window.serverPath + '/api/transaction/' + activityNo)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              this.transDetail = res.data.data
              this.loading = false
            }
          })
          .catch((err) => console.log(err))
      }
    }
  }
}
</script>

<style scoped>
.transaction_detail_box {
  height: 100%;
  background: #efefef;
}

.transaction_detail {
  margin: 0.12rem 0.16rem;
  width: calc(100% - 0.32rem);
  padding: 0.16rem;
  box-sizing: border-box;
  border-radius: 0.16rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.transaction_amount {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.36rem;
  line-height: 0.44rem;
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
  direction: ltr;
}

.dollar_icon {
  font-size: 0.2rem;
  line-height: 0.36rem;
  margin-inline-end: 0.04rem;
}

.transaction_status {
  color: #2f2f2f;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  margin-top: 0.04rem;
}

.pending {
  color: #ec9b00;
}

.error {
  color: #ff4c62;
}

.fail_reason {
  color: #ff4c62;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  margin-top: 0.04rem;
}

.transaction_description {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  margin-top: 0.04rem;
}

.trans_item {
  font-size: 0.14rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 0.12rem;
}

.trans_item_name {
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
}

.trans_item_result {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/views/TransactionDetail.vue